<template>
  <div>
    <PageAllow controller="Economies" action="index" />
    <Breadcrumbs :items="items" />
    <!-- <v-slide-x-transition> -->
    <v-sheet class="transparent-background-color">
      <v-sheet class="transparent-background-color">
        <v-row class="mx-5" dense>
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                show-radios
                :radios="datetimeRadios"
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="economy_code"
                    v-model="options.economy_code"
                    @text="Keyword = $event"
                    :label="$t('Economies.Fields.economy_code')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4"> </v-col>
                <v-col cols="12" sm="6" md="4"> </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-model="options.status"
                    :label="$t('Economies.Fields.status')"
                    :items="$consts.economiesFlgs"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-model="options.cancel_flgs"
                    :label="$t('Economies.Fields.cancel_flgs')"
                    :items="$consts.cancelFlgs"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-sheet>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="economies"
          :options.sync="options"
          :page.sync="paging.page"
          :loading="loading"
          :server-items-length="paging.count"
          mobile-breakpoint="800"
          multi-sort
          class="elevation-2 px-4 pt-1"
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <template v-slot:item.actions="{ item }">
            <!-- 明细 -->
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  v-bind="attrs"
                  v-on="on"
                  dark
                  color="info"
                  class="px-2 me-2"
                  :href="'/#/economies/' + item.id"
                >
                  <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                  {{ $t("Economies.detail") }}
                </v-btn>
              </template>
              <span>{{ $t("CRUD.viewInfo", [$t("Economies.detail")]) }}</span>
            </v-tooltip>
            <!-- 定价 -->
            <v-tooltip top v-if="item.actions.confirm">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  v-bind="attrs"
                  v-on="on"
                  dark
                  color="action"
                  class="px-2 me-2"
                  @click="Confirm(item.id)"
                >
                  <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                  {{ $t("Economies.economies") }}
                </v-btn>
              </template>
              <span>{{
                $t("CRUD.viewInfo", [$t("Economies.economies")])
              }}</span>
            </v-tooltip>
            <!-- 导出 -->
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  v-bind="attrs"
                  v-on="on"
                  dark
                  color="print"
                  class="px-2 me-2"
                  @click="Export(item.id)"
                >
                  <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                  {{ $t("Economies.export") }}
                </v-btn>
              </template>
              <span>{{ $t("CRUD.viewInfo", [$t("Economies.export")]) }}</span>
            </v-tooltip>
            <!-- 作废 -->
            <v-tooltip top v-if="item.actions.cancel">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  v-bind="attrs"
                  v-on="on"
                  dark
                  color="danger"
                  class="px-2 me-2"
                  @click="Cancel(item.id)"
                >
                  <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                  {{ $t("Economies.cancel") }}
                </v-btn>
              </template>
              <span>{{ $t("CRUD.viewInfo", [$t("Economies.cancel")]) }}</span>
            </v-tooltip>
          </template>

          <template v-slot:item.name>
            {{ accountName }}
          </template>
          <template v-slot:item.created="{ item }">
            {{ item.created | formatTime }}
          </template>
          <template v-slot:item.complete_date="{ item }">
            {{ item.complete_date | formatTime }}
          </template>
          <template v-slot:item.status="{ item }">
            <!-- {{item.cancel_flg}} -->
            <v-chip
              small
              label
              :color="item.cancel_flg == 1 ? 'danger' : 'primary'"
              :text-color="item.status | economiesFlgsTextColor"
            >
              {{ item.status | economiesFlgsText }}
              <span v-if="item.cancel_flg == 1">
                {{ "(" }}{{ item.cancel_flg | cancelFlgsText }}{{ ")" }}
              </span>
            </v-chip>
          </template>
        </v-data-table>
      </div>
    </v-sheet>
    <!-- </v-slide-x-transition> -->
  </div>
</template>

<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import Economies from "@/api/economies";
import SearcherStatus from "@/components/plugins/SearcherStatus";

const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  economy_code: "",
  status: [1, 2, 3],
  cancel_flgs: [0, 1],
};

export default {
  data: () => ({
    loading: false,
    options: JSON.parse(JSON.stringify(defaultOptions)),
    Keyword: "",
    paging: {},
    economies: [],
  }),

  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    SearcherKeyword,
    SearcherStatus,
  },

  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    accountName() {
      if (this.accountInfo) {
        return this.accountInfo.account_name;
      }
    },
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.economies"),
        disabled: false,
        href: "/economies",
      },
      {
        text: i18n.t("Nav.economiesIndex"),
        disabled: true,
        href: "/economies",
      },
    ],
    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("Economies.Fields.created"),
      },
    ],

    headers() {
      return [
        {
          text: i18n.t("Economies.Fields.economy_code"),
          align: "start",
          sortable: false,
          value: "economy_code",
        },
        {
          text: i18n.t("Economies.Fields.name",[this.$consts.shopName()]),
          align: "start",
          sortable: false,
          value: "name",
        },
        {
          text: i18n.t("Economies.Fields.created"),
          align: "start",
          sortable: false,
          value: "created",
        },
        {
          text: i18n.t("Economies.Fields.economy_time"),
          align: "start",
          sortable: false,
          value: "complete_date",
        },
        {
          text: i18n.t("Economies.Fields.status"),
          align: "center",
          sortable: false,
          value: "status",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        },
      ];
    },
    ...mapState(["accountInfo", "settings"]),
  },

  mounted() {
    this.$commonUtils.loadOptions("economies").then(
      function (data) {
        if (data.options) {
          this.options = data.options;
        } else this.resetSearch();
      }.bind(this)
    );
  },

  methods: {
    onSearch() {
      this.options = Object.assign(this.options, {
        economy_code: this.Keyword,
      });
      this.getEcononmiesFromAPI();
    },
    resetSearch() {
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },

    getEcononmiesFromAPI() {
      this.loading = true;
      Economies.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.economies = response.data.economies;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },

    Cancel(id) {
      this.$store.dispatch("fullscreenLoading");
      Economies.cancel(id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getEcononmiesFromAPI();
          }
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      );
    },
    Confirm(id) {
      this.$store.dispatch("fullscreenLoading");
      Economies.confirm(id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getEcononmiesFromAPI();
          }
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      );
    },
    Export(id) {
      Economies.exportOne(Object.assign(id));
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.getEcononmiesFromAPI();
        sessionStorage.setItem(
          "economies-options",
          JSON.stringify(this.options)
        );
      },
    },
  },
};
</script>


<style>
</style>